export default [
  { id: 1, name: "Checking" },
  { id: 2, name: "Savings" },
];
